<template>
  <div class="container">
    <div v-if="showList" class="background-container" @click="onShowList"></div>
    <div class="main-container" :style="customStyle" @click="onShowList">
      <img v-if="!selectedItem" src="@/assets/images/select.png" class="add-icon" alt="add" />
      <text-flow-button-icon v-if="selectedItem" :name="selectedItem" type="large" />
    </div>
    <div v-if="showList" class="list">
      <span class="section-title" style="margin-top: 10px;">
        Action
      </span>
      <div class="list-item" @mouseover="switchLists('person')">
        <text-flow-button-icon name="route_person" />
        <span class="item-name">Route to a person</span>
        <img src="@/assets/images/next.svg" style="width: 7px; height: 12px;" alt="next" />
        <div v-if="hoverPerson" class="list more">
          <div v-for="(item, index) in team" :key="index" class="list-item" @click="onClickItem('route_person', item)">
            <div class="item-avatar" :style="'background-color: ' + item.avatarColor">
              {{ item.avatarName }}
            </div>
            <div class="item-name">
              {{ item.name || item.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="groups && Array.isArray(groups) && groups.length > 0"
        class="list-item"
        @mouseover="switchLists('group')"
      >
        <text-flow-button-icon name="route_group" />
        <span class="item-name">
          Route to group
        </span>
        <img src="@/assets/images/next.svg" style="width: 7px; height: 12px;" alt="next" />
        <div v-if="hoverGroup" class="list more">
          <div v-for="(item, index) in groups" :key="index" class="list-item" @click="onClickItem('route_group', item)">
            <div class="item-avatar group" :style="'background-color: ' + item.avatarColor">
              {{ item.avatarName }}
            </div>
            <div class="item-name">
              {{ item.name }}
            </div>
          </div>
        </div>
      </div>
  
         <div class="list-item" @mouseover =          "noDisplay" @click="onClickItemData('noassign', null)" >
        <text-flow-button-icon name="route_person" />
        <span class="item-name">Route to everyone</span>
       
      </div>
    
        
    
  
  
  
    </div>
  </div>
</template>

<script>
import TextFlowButtonIcon from './TextFlowButtonIcon';

export default {
  name: 'TextFlowButton',
  components: { TextFlowButtonIcon },
  props: {
    customStyle: String,
    team: Array,
    groups: Array,
    onSelect: Function,
    selectedItem: String,
    type: String
  },
  data() {
    return {
      showList: false,
      hoverPerson: false,
      hoverGroup: false
    };
  },
  methods: {
    onShowList() {
      this.showList = !this.showList;
    },
    onClickItem(item, data) {
      this.showList = false;
      this.hoverPerson = false;
      this.hoverGroup = false;
      this.onSelect(item, data, this.type);
    },
    switchLists(listType = '') {
      if (listType === 'person') {
        this.hoverGroup = false;
        return (this.hoverPerson = true);
      }
      this.hoverGroup = true;
      return (this.hoverPerson = false);
    },
              noDisplay ()
   {
       this.hoverGroup = false;
       this.hoverPerson = false;
  



   }, 
    onClickItemData(item, data) {
      this.showList = false;
      this.hoverPerson = false;
      this.hoverGroup = false;
      this.onSelect(item, data, this.type, this.id);
    },
 
  }
};
</script>

<style scoped lang="scss">
.container {
  position: relative;
  width: 45px;
  height: 45px;
}
.background-container {
  position: fixed;
  left: 0vw;
  top: 0vh;
  width: 100vw;
  height: 100vh;
}
.main-container {
  position: relative;
  width: 45px;
  height: 45px;
  background: #ffffff;
  border: 0.2px solid #d4d6d8;
  box-sizing: border-box;
  box-shadow: 0px 2px 10px rgba(83, 95, 119, 0.15), 0px 3px 2px rgba(83, 95, 119, 0.2);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .add-icon {
    width: 22px;
    height: 22px;
  }
}
.list {
  position: absolute;
  top: 50px;
  width: 225px;
  background: #ffffff;
  border: 0.2px solid #d4d6d8;
  box-shadow: 2px 2px 10px rgba(83, 95, 119, 0.15);
  border-radius: 5px;
  padding: 10px 0;
  z-index: 100;
  &.more {
    left: 215px;
    top: 0;
    bottom: unset;
    max-height: 197px;
    overflow: auto;
  }
  .section-title {
    display: block;
    font-size: 12px;
    line-height: 20px;
    letter-spacing: -0.01em;
    color: $colorPlaceholder;
    margin-left: 15px;
  }
  .list-item {
    position: relative;
    width: 100%;
    height: 45px;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    padding: 0 10px;
    &:hover {
      background-color: $colorBack;
    }
    .item-avatar {
      width: 25px;
      height: 25px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      text-align: center;
      letter-spacing: 0.03em;
      color: #ffffff;
      &.group {
        border-radius: 5px;
      }
    }
    .item-name {
      flex: 1;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.01em;
      margin-left: 20px;
      color: $colorText;
    }
  }
}
</style>
 